import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { IframeSecurityService } from 'src/app/shared/services/iframe-security.service';
import { UserAccessRulesService } from 'src/app/shared/services/user-access-rules/user-access-rules.service';

import { LoginService } from 'src/app/shared/services/login.service';
import { NetworkService } from 'src/app/shared/services/network.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private loginService: LoginService,
    private router: Router,
    private iframeSecurityService: IframeSecurityService,
    private userAccessRulesService: UserAccessRulesService,
    private networkService: NetworkService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.loginService.isLoggedIn()) {
      this.accessDeniedLoadingData(state);
      this.accessDeniedToOrigin(state);
      this.accessIsAvailableOffline(state);

      if (
        state.url === '/carga' ||
        state.url === '/' ||
        state.url === '/contacts' ||
        (state.url === '/pdf-custom' && this.canAccessAlias(state)) ||
        (localStorage.getItem('userAccessRules') && this.isUserAccessAllowed(state) && this.canAccessAlias(state))
      ) {
        return true;
      } else {
        this.router.navigate(['access-denied']);
        return false;
      }
    } else {
      this.router.navigate(['login']);
      return false;
    }
  }

  isUserAccessAllowed(state: RouterStateSnapshot): boolean {
    return this.userAccessRulesService.isUserAccessAllowed(state.url);
  }

  accessIsAvailableOffline(state: RouterStateSnapshot): void {
    if (
      !this.networkService.getConnectionStatus().status &&
      (state.url.includes('notifications') ||
        state.url.includes('settings') ||
        state.url.includes('customers/new') ||
        state.url.includes('customers/edit') ||
        state.url.includes('prospects/new') ||
        state.url.includes('prospects/edit') ||
        state.url.includes('contacts/new') ||
        state.url.includes('sales-goals') ||
        state.url.includes('contacts/edit'))
    ) {
      this.router.navigate(['not-available']);
    }
  }

  accessDeniedLoadingData(state: RouterStateSnapshot): void {
    if (
      localStorage.getItem('isFullDataLoadSync') !== 'true' &&
      (state.url.includes('sales-order/details/') ||
        state.url.includes('sales-order/maintenance/') ||
        state.url.includes('sales-budget'))
    ) {
      this.router.navigate(['/access-denied-loading-data'], { queryParams: { page: state.url.replace('/', '') } });
    }
  }

  accessDeniedToOrigin(state: RouterStateSnapshot): void {
    const { url } = state;
    const frameBlockedRoute = '/frame-blocked';
    const insideIframe = window.self !== window.top;
    const notOnFrameBlocked = url !== frameBlockedRoute;
    const routeNotAllowed = !this.iframeSecurityService.isRouteAllowedForOrigin(url);

    if (insideIframe && routeNotAllowed && notOnFrameBlocked) {
      this.router.navigate([frameBlockedRoute]);
    }
  }

  canAccessAlias(state: RouterStateSnapshot): boolean {
    return state.url.includes('sales-goals') || state.url.includes('pdf-custom')? this.userAccessRulesService.canAccessMenuVersion(state.url) : true;
  }
}
